/** @format */
import _Footers from './Footers';
import _LandingPageHeader from './Header/LandingPageHeader';
import _Info from './Info/Info';

export const LandingPageHeader = _LandingPageHeader;
export const DemoFooter = _Footers;
export const Info = _Info;
